<div *ngIf="!!title" class="title">{{title}}</div>
<div class="text">
  {{message}}
</div>
<button (click)="close()">{{'components.popups.close' | translate | async}}</button>
